/**
 * Session tracking utilities for quote view analytics
 */

// Generate or retrieve session ID
export function getSessionId() {
  let sessionId = sessionStorage.getItem('quote_session_id');
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem('quote_session_id', sessionId);
  }
  return sessionId;
}
